import { ReactNode, FC, createContext, useState, useMemo } from 'react';

import * as types from '@models/types';

type RiskType =
    | 'glriRank'
    | 'greenRank'
    | 'ability'
    | 'knowledge'
    | 'skills'
    | 'workActivity'
    | 'occupationPerc'
    | { section: 'sectorScore', data: any[] };

type GlobeContextType = {
    hoveredCountry?: string | null;
    setHoveredCountry?: React.Dispatch<React.SetStateAction<string | null>>;
    selectedCountry?: string | null;
    setSelectedCountry?: React.Dispatch<React.SetStateAction<string | null>>;
    globePosition?: types.CountryType | null;
    setGlobePosition?: React.Dispatch<React.SetStateAction<types.CountryType | null>>;
    globeRisk?: RiskType;
    setGlobeRisk?: React.Dispatch<React.SetStateAction<RiskType>>;
    globeData?: any[];
    setGlobeData?: React.Dispatch<React.SetStateAction<any[]>>;
    selectedProvinces?: any[];
    setSelectedProvinces?: React.Dispatch<React.SetStateAction<any[]>>;
};

const GlobeContext = createContext<GlobeContextType>({});

type GlobeProps = {
    children: ReactNode;
};

const Globe: FC<GlobeProps> = ({ children }) => {
    const [globePosition, setGlobePosition] = useState<types.CountryType | null>(null);
    const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
    const [hoveredCountry, setHoveredCountry] = useState<string | null>(null);
    const [globeRisk, setGlobeRisk] = useState<RiskType>('glriRank');
    const [globeData, setGlobeData] = useState<any[]>([]);
    const [selectedProvinces, setSelectedProvinces] = useState<any[]>([]);

    const GlobeProviderValue = useMemo(
        () => ({
            globePosition,
            setGlobePosition,
            globeRisk,
            setGlobeRisk,
            selectedCountry,
            setSelectedCountry,
            hoveredCountry,
            setHoveredCountry,
            globeData,
            setGlobeData,
            selectedProvinces, setSelectedProvinces
        }),
        [
            globePosition,
            setGlobePosition,
            globeRisk,
            setGlobeRisk,
            selectedCountry,
            setSelectedCountry,
            hoveredCountry,
            setHoveredCountry,
            globeData,
            setGlobeData,
            selectedProvinces, setSelectedProvinces
        ],
    );

    return (
        <GlobeContext.Provider value={GlobeProviderValue}>
            {children}
        </GlobeContext.Provider>
    );
};

export { Globe, GlobeContext };
